import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SmashCircularProgressComponent } from './smash-circular-progress/smash-circular-progress.component';


@NgModule({
  declarations: [
    SmashCircularProgressComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    CommonModule
  ],
  exports: [
    SmashCircularProgressComponent
  ]
})
export class SmashCircularProgressModule { }
